module.exports = __webpack_public_path__ + "2ad0c010afa42fadda955306a949421b.glb";